<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" max-width="500">
      <template v-slot:activator="{ on }">
        <v-btn small flat color="success"  dark v-on="on" @click="check_user" >Deposer</v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
          color="success"
        >Depot PerfectMoney</v-card-title>
        <v-flex xs12 text-xs-center mb-3>
          <img src="/img/perfectmoney.png" alt="perfectmoney" width="70" height="70" />
        </v-flex>

        <form action="https://perfectmoney.com/api/step1.asp" target='_blank' @submit="setAmount" method="POST">
          <p>
            <v-text-field solo type="number" label="Montant" v-model="amount" class="first"></v-text-field>
            <input type="hidden" name="PAYEE_ACCOUNT" value="U10777775" />
            <input type="hidden" name="PAYEE_NAME" value="HIROPAY" />
            <input id="amount" type="hidden" name="PAYMENT_AMOUNT" value />
            <input type="hidden" name="PAYMENT_UNITS" value="USD" />
            <input id="status_url" type="hidden" name="STATUS_URL" value />
            <input id="payment_id" type="hidden" name="PAYMENT_ID" value />
            <input id="payment_url" type="hidden" name="PAYMENT_URL" value />
            <input id="nopayment_url" type="hidden" name="NOPAYMENT_URL" value />
            <input type="hidden" name="BAGGAGE_FIELDS" value="ORDER_NUM CUST_NUM" />
            <input id="order_num" type="hidden" name="ORDER_NUM" value />
            <input id="cust_id" type="hidden" name="CUST_NUM" value />
            <v-divider></v-divider>
            <v-flex xs12 text-xs-right>
              <v-btn color="success" type="submit" >DEPOSIT PM</v-btn>
            </v-flex>
          </p>
        </form>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="success" depressed @click="dialog = false">fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firebase from "../../../fb";
import db from "../../../db";
export default {
  components: {},
  data() {
    return {
      dialog: false,
      amount: '',
      order_num: process.env.VUE_APP_SECRET,
      cust_id: "",
      payment_id: "",
      
    };
  },

  computed: {
    nopayment_url() {
      return `${this.main_api}/app/no_payment_pm` 
    },
    status_url(){
      return `${this.base_url}/external/status_pm`
    },
    payment_url(){
      return `${this.main_api}/app/payment_pm`
    },

  },
  methods: {
    async setAmount() {
      console.log(this.payment_url);
      console.log(this.status_url);
      console.log(this.nopayment_url);
      let am = Number(this.amount);
      if (am > 0) {
        var user = firebase.auth().currentUser;
        this.cust_id = user.uid;
        let await_ref =  await db.collection('await_pm_deposit').doc()
        this.payment_id = await_ref.id
        let data_set ={
          id:await_ref.id,
          amount:Number(this.amount),
          user_id:user.uid,
          status:'attente',
          created_at: firebase.firestore.FieldValue.serverTimestamp()
        }
        await_ref.set(data_set).then(()=>{
          console.log('doc set');
        }).catch((e)=>{
          console.log(e);
        })
        const setAttribute = x => {
          var a = document.getElementById(x);
          a.setAttribute("value", this[x]);
        };
        setAttribute("amount");
        setAttribute("nopayment_url");
        setAttribute("status_url");
        setAttribute("payment_url");
        setAttribute("cust_id");
        setAttribute("payment_id");
        setAttribute("order_num");
        this.amount=''
        this.dialog=false
      } else {
        console.log('montant inféfieur à 0');
      }
    },
    check_user(){
       let user = this.$store.getters['authfb/user']
      if (!user) {
        swal("Erreur survenu!", "contactez le support et fournissez votre email pour assistance avant d'effecturer le dépot!", "error", {
            button: "ok"
          })
          setTimeout(() => {
            this.dialog = false
          }, 1000);
        
      }
    },
  }
};
</script>

<style scoped>
td.md-table-cell {
  font-size: 1.2em;
}
.first {
  max-width: 200px !important;
  display: block;
  margin: auto;
}
div.v-input.first {
  font-size: 2em !important;
  align-content: center;
}
</style>

<style >
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
